import { setStoreValue } from 'pulsy';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const API_URL = API_BASE_URL;

export const login = async (username, password) => {
  try {
    const response = await axios.post(`${API_URL}/login`, { username, password });
    const { token } = response.data;

    // stoor JWT (JSON Web Token) vir validation
    localStorage.setItem('auth_token', token);

    // Validate token and stoor user/role vanaf backend
    const valid = await validateToken();
    return valid;
  } catch (error) {
    console.error('Login failed', error);
    return false;
  }
};



export const validateToken = async () => {
  try {
    const token = localStorage.getItem('auth_token');
    const response = await axios.get(`${API_URL}/validate`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const user = response.data.user;
    console.log(user)

    // Werk die stoor by met die gebruiker se inligting insluitend rol
    setStoreValue('auth', { user, token: localStorage.getItem('auth_token'), role: user.role });
    return true;
  } catch (error) {
    console.error('Token validation failed', error);
    return false;
  }
};

export const logout = () => {
  setStoreValue('auth', { user: null, token: null, role: null });
  localStorage.removeItem('auth_token');
  localStorage.removeItem('pulsy_auth');
};